import { useFormikContext, ErrorMessage } from "formik";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FieldErrors from "../../../../components/v2-mobili/errors/FieldErrors";

const propertyOptions = [
  ...Array(10)
    .fill()
    .map((_, index) => `Tipo ${index + 1}`),
];
const PropertyTypeField = ({ readOnly = false }) => {
  const { getFieldProps, errors, touched } = useFormikContext();
  return (
    <Grid container flexDirection="column" item>
      <TextField
        select
        error={errors.propertyType && touched.propertyType}
        size="small"
        label="Tipo de Propiedad"
        InputProps={{
          readOnly: readOnly,
        }}
        {...getFieldProps("propertyType")}
      >
        {propertyOptions.map((option, key) => (
          <MenuItem key={key} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <FieldErrors>
        <ErrorMessage name="propertyType" />
      </FieldErrors>
    </Grid>
  );
};

export default PropertyTypeField;
